module.exports = __webpack_public_path__ + "img/congress of sages.4496bc5f.png";